import { useSupabaseStore } from "@/store/zustand/supabaseStore";

interface ProjectStatus {
  id: string;
  name: string;
  type: string;
  isDefault: boolean;
}

export const validateCustomStatus = async (
  projectId: string,
  statusName: string,
  isDefaultStatus: boolean,
): Promise<{ isValid: boolean; error?: string }> => {
  if (isDefaultStatus) {
    return { isValid: true };
  }

  const supabaseClient = useSupabaseStore.getState().supabaseClient;

  if (!supabaseClient || !projectId) {
    return { isValid: false, error: "Client or project not available" };
  }

  try {
    // Fetch current project data to check if status still exists
    const { data: project, error } = await supabaseClient
      .from("projects")
      .select("statuses")
      .eq("id", projectId)
      .single();

    if (error) {
      console.error("Error fetching project statuses:", error);
      return { isValid: false, error: "Failed to validate status" };
    }

    if (!project?.statuses) {
      return { isValid: false, error: "Project statuses not found" };
    }

    const projectStatuses: ProjectStatus[] = project.statuses;
    const statusExists = projectStatuses.some(
      (status) => status.name === statusName && !status.isDefault,
    );

    if (!statusExists) {
      return {
        isValid: false,
        error: `Cannot update to this status - it has been deleted or updated`,
      };
    }

    return { isValid: true };
  } catch (error) {
    console.error("Error validating custom status:", error);
    return { isValid: false, error: "Failed to validate status" };
  }
};
